import { declareVueComponent } from '/vodalys/vvuejs'

import VrunFormSelectCellComponent from './VrunFormSelectCellComponent.vue'

declareVueComponent('vrunFormSelectCellComponent', VrunFormSelectCellComponent)